
import { defineComponent } from 'vue'
import { getCardImage } from '~/utils/billing'

export default defineComponent({
  name: 'V2PaymentMethodRow',
  props: {
    id: {
      type: String,
      required: true
    },
    brand: {
      type: String,
      required: true
    },
    brandLabel: {
      type: String,
      required: true
    },
    lastFour: {
      type: String,
      required: true
    },
    expiryLabel: {
      type: String,
      required: true
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cardImage(): string {
      return getCardImage(this.brand)
    }
  }
})
